import { autoRegisterFeature } from '@store/features/factory';
import { useModal } from '@store/hooks';

import { MODAL_TYPES } from '../../components/modals/constants';

import { feedbackFeature } from './store/feature';
import type { CSATConfig } from './types';

// Auto-register the feature when this module is imported
autoRegisterFeature(feedbackFeature);

/**
 * Hook for opening CSAT (Customer Satisfaction) modals
 */
export function useCSAT() {
  const { open } = useModal();

  const openCSATModal = (config: CSATConfig) => {
    open(MODAL_TYPES.CSAT, config);
  };

  return { openCSATModal };
}

// Export store (all store-related exports)
export * from './store';

// Export hooks
export * from './hooks';

// Export types
export type { CSATCheckboxOption, CSATConfig, CSATContext, CSATSupportLink } from './types';

// Export constants
export {
  DEFAULT_CHECKBOX_OPTIONS,
  DEFAULT_RATING_MODAL_SUBTITLE,
  DEFAULT_RATING_MODAL_TITLE,
} from './constants';
